import { render, staticRenderFns } from "./Inscritos.vue?vue&type=template&id=24bd1b18&"
import script from "./Inscritos.vue?vue&type=script&lang=js&"
export * from "./Inscritos.vue?vue&type=script&lang=js&"
import style0 from "./Inscritos.vue?vue&type=style&index=0&id=24bd1b18&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports